import React from 'react'; 
import ImageOptimized from '../components/ImageOptimized';
import ceoImage from '../assets/ceo.jpg';
// import { Link } from 'react-router-dom';
import RatesImage from "../assets/Rates.jpg";


const About = () => {

  const whatsapp = '+233202208006';

  return (
    <>
      {/* Existing About Section */}
      <section className="about-section">
        <h1>Who Are We?</h1>
        <div className="about-content">
          <ImageOptimized alt="Our Team" className="team-photo float-image" />
          <p>
            Vocal Factory Global is a hub dedicated to identifying and addressing the unique vocal challenges
            faced by individuals. We are committed to improving and refining the singing abilities and gifts
            that God has placed in everyone. Rooted in the belief that anyone can sing with proper study and guidance,
            we provide a holistic approach to vocal training and artistic development. 
            <br />
            <br />
            In addition to nurturing vocal talents, we offer a wide range of services designed to support your musical
            journey. These include; Songwriting, Overdubs, Vocal Production, Live Concert Background Vocals and many more.
          </p>
        </div>
      </section>

      {/* New CEO Section */}
      <section className="ceo-section">
        <div className="ceo-header">Meet the CEO</div>
        <div className="ceo-content">
          <div className="ceo-text">
            <p>
              <strong>SITSO</strong> brings a unique blend of skills and expertise that sets the tone for everything we do. 
              With a background in counselling and psychology and formal training in the finance and management field, 
              he combines sharp business acumen with deep understanding of people. 
            </p>
            <p>
              As an expert in Scrum and agile methodologies, he brings a structured, yet flexible approach 
              to managing projects and teams.
            </p>
            <p>
              But that is not all—our CEO's passion lies in music. With over a decade of experience in vocal production, 
              direction, and coaching, his natural musical talent has been nurtured through years of hands-on work, 
              helping countless artists and teams achieve vocal excellence.
            </p>
            <p>
              As a leader, he tailors his leadership styles to meet the unique needs of every team. 
              More than just a leader, he is a trainer of leaders, 
              empowering those he mentors to represent him and 
              Vocal Factory Global with confidence and skill.
            </p>
          </div>
          <div className="ceo-image-wrap">
            <img src={ceoImage} alt="CEO Singing" className="ceo-image" />
          </div>
        </div>
      </section>

      {/* Why Choose Us Card transformed to Rates Card */}
          <div className="card center-card">
            <img
              src={RatesImage}
              alt="Why Choose Us"
              style={{ width: 400, height: 400, objectFit: "cover", borderRadius: "90px" }}
            />
            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 700, fontSize: "20px" }}>Contact Us For Our Rates</div>
              <div style={{ color: "var(--muted)", marginTop: 6, marginBottom: 12 }}>
                ↓ ↓ 
              </div>
              <a className="btn" href={`https://wa.me/${whatsapp.replace(/[^\d]/g,'')}?text=Hi%20I%20found%20you%20on%20the%20website`} target="_blank" rel="noreferrer">Get Rates</a>
            </div>
          </div>
    </>
  );
};

export default About;